var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grey-box"},[_c('div',{staticClass:"center-box"},[_vm._m(0),_c('div',{staticClass:"message"},[_vm._v(" 您已完成看样决策，"),_c('span',[_vm._v(_vm._s(_vm.scond + "秒"))]),_vm._v("后自动跳转 ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-box"},[_c('i',{staticClass:"icon-gou1 iconfont"})])
}]

export { render, staticRenderFns }